import SectionDivider from "./common/SectionDivider";
import {Carousel} from "flowbite-react";
import Point from "./common/Point";
import {points} from "../data/data";
import {oemBanners} from "../data/banners";
import {useTranslation} from "react-i18next";
import {NewlineText} from "./common/NewlineText";


const theme = {
    "root": {
        "base": "overflow-hidden no-scrollbar relative w-full mx-24 max-w-screen-lg aspect-[2] max-md:aspect-[1]",
        "leftControl": "absolute left-0 top-0 flex h-full items-center justify-center px-4 focus:outline-none",
        "rightControl": "absolute right-0 top-0 flex h-full items-center justify-center px-4 focus:outline-none"
    },
    "indicators": {
        "active": {
            "off": "bg-white/50",
            "on": "bg-white w-8"
        },
        "base": "h-1.5 w-6 rounded-sm",
        "wrapper": "absolute bottom-4 left-1/2 flex -translate-x-1/2 space-x-2"
    },
    "item": {
        "base": "absolute left-1/2 top-1/2 block w-full -translate-x-1/2 -translate-y-1/2",
        "wrapper": {
            "off": "w-full flex-shrink-0 transform cursor-default snap-center",
            "on": "w-full flex-shrink-0 transform cursor-grab snap-center"
        }
    },
    "control": {
        "base": "w-0 h-0",
        "icon": "w-0 h-0",
    },
    "scrollContainer": {
        "base": "flex h-full snap-mandatory overflow-y-hidden overflow-x-scroll scroll-smooth ease-out duration-800 rounded-[24px] md:rounded-[30px]",
        "snap": "snap-x"
    }
}

function OEMSection() {
    const {t} = useTranslation()
    return (
        <div className="section lg:bg-[image:linear-gradient(to_bottom,white_0%,white_40%,#8BDBBE_40%,#8BDBBE_100%)]">
            <h1 data-aos="fade-right"
                data-aos-duration="300"
                className="text-primary">{t('home_oem_header')}</h1>
            <SectionDivider/>
            <NewlineText className='max-w-screen-lg' text={t('home_oem_subtitle')}/>
            <Carousel theme={theme} slideInterval={5000}>
                {oemBanners.map((banner, index) => (
                    <img key={index} src={banner} alt="" className="object-cover h-full"/>
                ))}
            </Carousel>
            <div className="bg-secondary px-5 py-2 rounded-sm">
                <div className="font-bold text-primary text-2xl max-md:text-base">{t('home_oem_strong')}</div>
            </div>
            <div className="flex flex-wrap justify-center max-w-80 pt-12 max-md:pt-6">
                {points.map((point, index) => (
                    <div key={index} className="w-full md:w-1/2 lg:w-1/3 p-3">
                        <Point key={index} icon={point.icon} title={t(point.title)} content={t(point.content)} />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default OEMSection;
